// We assumed global variables our in Sprockets-based JavaScript,
// so any module bundled by Webpack would need to be exposed to the global scope somehow,
window.$ = window.jQuery = require('jquery');

require('jquery-ujs');
require('jquery-validation');
